<template>
	<div class="l-edit-dialog-box">
		<el-form :model="form_data" label-width="80px" ref="form" :rules="rules" label-position="left" v-loading="loading">
			<el-row>
				<el-col :span="11">
					<el-form-item label="上级权限" prop="pid">
						<el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
					</el-form-item>
				</el-col>

				<el-col :span="11" :offset="2">
					<el-form-item label="权限名称" prop="name">
						<el-input v-model="form_data.name" autocomplete="off" placeholder="请输入权限名称"></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item label="是否节点" prop="is_node">
						<el-radio-group v-model="form_data.is_node">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>

				<el-col :span="11" :offset="2">
					<el-form-item label="状态" prop="state">
						<el-radio-group v-model="form_data.state">
							<el-radio :label="1">启用</el-radio>
							<el-radio :label="0">禁用</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>

			<div v-if="visible && form_data.is_node === 0">
				<l-divider style="margin-top: 0px; margin-bottom: 0"></l-divider>
				<l-permission-resources-transfer @on-change="onResourcesChange" :permission-id="id" :use-type="useType"></l-permission-resources-transfer>
			</div>
		</el-form>
		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
import ResourcesTransfer from "./ResourcesTransfer";
export default {
	name: "l-permission-edit",
	components: {
		[ResourcesTransfer.name]: ResourcesTransfer,
	},
	props: {
		id: {
			type: [Number, String],
			default: "",
		},
		pid: {
			type: [String, Number],
			default: "",
		},
		visible: {
			type: Boolean,
		},
		useType: {
			type: Number,
			default: 1,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== "";
		},
	},
	data() {
		return {
			loading: false, //页面是否加载中

			//节点树
			tree_node: [],

			//模块列表
			module_list: [],

			//表单数据
			form_data: {
				pid: [],
				name: "",
				sort_num: 1000,
				state: 1,
				is_node: 1,
				checked_resources: [],
				re_checked_resources: [],
			},
			//表单验证规则
			rules: {
				pid: [{ type: "array", required: true, message: "请选择上级节点", trigger: "change" }],
				name: [{ required: true, message: "权限名称不能为空", trigger: "change" }],
				sort_num: [{ type: "number", required: true, message: "排序不能为空", trigger: "change" }],
				state: [{ type: "number", required: true, message: "请选择状态", trigger: "change" }],
				is_node: [{ type: "number", required: true, message: "请选择是否节点", trigger: "change" }],
			},
			//提交按钮是否显示加载中
			submitting: false,
		};
	},
	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getData();
				}
			},
		},
	},
	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//获取数据
		getData() {
			if (this.hasId) {
				//编辑初始化
				this.loading = true;
				this.$_invoke(`permission_getEditData`, {
					id: this.$props.id,
				})
					.then((ret) => {
						let { treeNode, info, list, targetKeys } = ret;
						this.tree_node = treeNode;
						this.module_list = ret.module_list;
						this.$nextTick(() => {
							//找到pid所属的路径
							const curr_p_data = list.find((item) => {
								return item.id == info.pid;
							});
							let p_path_arr = curr_p_data.path.split(">");
							p_path_arr = p_path_arr.filter((item) => {
								return item != "";
							});
							p_path_arr = p_path_arr.map((item) => {
								return parseInt(item);
							});
							p_path_arr.push(info.pid);
							p_path_arr.splice(0, 1);
							info.pid = p_path_arr;
							info.re_checked_resources = targetKeys;
							this.form_data = info;
						});
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				//添加初始化
				this.$_invoke("permission_getTreeNode", {})
					.then((ret) => {
						const { list, tree_node } = ret;
						this.tree_node = tree_node;
						this.$nextTick(() => {
							if (this.$props.pid) {
								//找到pid所属的路径
								const curr_p_data = list.find((item) => {
									return item.id == this.$props.pid;
								});
								let p_path_arr = curr_p_data.path.split(">");
								p_path_arr = p_path_arr.filter((item) => {
									return item != "";
								});
								p_path_arr = p_path_arr.map((item) => {
									return parseInt(item);
								});
								p_path_arr.splice(0, 1);
								p_path_arr.push(this.$props.pid);
								this.form_data.is_node = 0;
								// console.log(p_path_arr);
								this.form_data.pid = p_path_arr;
							}
						});
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},

		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.submitting = true;
					let form_data = Object.assign({}, this.form_data);
					const pid_len = form_data.pid.length;
					form_data.pid = form_data.pid[pid_len - 1];
					if (!this.hasId) {
						//添加
						this.$_invoke("permission_save", form_data)
							.then(() => {
								this.$_msg.success("添加成功");
								this.$emit("on-success");
							})
							.finally(() => {
								this.submitting = false;
							});
					} else {
						//修改
						this.$_invoke(`permission_update`, form_data)
							.then(() => {
								this.$_msg.success("修改成功");
								this.$emit("on-success");
							})
							.finally(() => {
								this.submitting = false;
							});
					}
				}
			});
		},

		//监听资源选择变化
		onResourcesChange(checked_resources) {
			this.form_data.checked_resources = checked_resources;
		},
	},
};
</script>
